module.exports = __webpack_public_path__ + "img/15.9b3aa723.png";